import type { BlockMarquee } from 'types/block-marquee';
import React, { useMemo } from 'react';
import { Heading } from '@leafwell/components';
import Figure from './figure';

export type MarqueeContentProps = Omit<BlockMarquee, 'acfFcLayout'> & {
  type?: 'left' | 'reverse';
};

const MarqueeItem: React.FC<Omit<MarqueeContentProps, 'type'>> = ({
  content,
  icon,
}) => {
  return (
    <div className="flex items-center gap-x-6 mx-3">
      <Heading tagName="p" level="3" className="font-sans">
        {content}
      </Heading>
      {icon && <Figure {...icon} className="w-10 h-10" objectFit="contain" />}
    </div>
  );
};

const MarqueeContent: React.FC<MarqueeContentProps> = ({
  type = 'left',
  content,
  icon,
}) => {
  const contentClass = useMemo(() => {
    switch (type) {
      case 'left':
      default:
        return 'motion-safe:animate-marquee-left ';
      case 'reverse':
        return 'absolute top-0 motion-safe:animate-marquee-reverse';
    }
  }, [type]);

  return (
    <div className={['flex py-12 whitespace-nowrap', contentClass].join(' ')}>
      {[...Array(4)].map((_, idx) => (
        <MarqueeItem key={idx} content={content} icon={icon} />
      ))}
    </div>
  );
};

const Marquee: React.FC<BlockMarquee> = ({ content, icon }) => {
  return (
    <div className="grid relative w-full overflow-hidden marquee">
      <MarqueeContent type="left" content={content} icon={icon} />
      <MarqueeContent type="reverse" content={content} icon={icon} />
    </div>
  );
};

export default Marquee;
